import { get } from 'lodash';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { featureConfig } from './config';

// featureId supports nested loadsh notation a.b.c
export const checkFeature = (featureId, defaultValue = false) => {
  return get(featureConfig, `${CURRENT_PRODUCT_MODE}.${featureId}`, defaultValue);
};

// why not
export const prefixedCheckFeature =
  (prefixId) =>
  (featureId, defaultValue = false) =>
    checkFeature(`${prefixId}.${featureId}`, defaultValue);
